import React from 'react';
import { Skeleton, Card, CardContent, Grid, Box } from '@mui/material';

const CardSkeleton = ({
  count = 8,
  animation = 'pulse',
  variant = 'text',
  width = '100%',
  height = 75,
  sx = {}
}) => {
  return (
    <Grid container spacing={2}>
      {[...Array(count)].map((_, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card>
            <CardContent>
              <Box display="flex" alignItems="center" mb={1}>
                <Skeleton
                  variant="circular"
                  width={40}
                  height={40}
                  animation={animation}
                  sx={sx}
                />
                <Box ml={2} flexGrow={1}>
                  <Skeleton
                    height={20}
                    width="80%"
                    animation={animation}
                    sx={sx}
                  />
                  <Skeleton
                    height={15}
                    width="60%"
                    animation={animation}
                    sx={sx}
                  />
                </Box>
              </Box>
              <Skeleton
                variant={variant}
                height={height}
                width={width}
                animation={animation}
                sx={sx}
              />
              <Box mt={2}>
                <Skeleton
                  height={15}
                  width="70%"
                  animation={animation}
                  sx={sx}
                />
                <Skeleton
                  height={15}
                  width="40%"
                  animation={animation}
                  sx={sx}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default CardSkeleton;
